<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-row>
        <v-col lg="12">
          <data-table
            ref="tableVacaciones"
            :showAdvancedFilters="false"
            :url="url"
            :columns="columns"
            :filters="filters"
            @setFilters="setFilters"
            @loadModalData="loadModalData"
            :perPage="[10, 25, 50, 100]"
          >
            <template slot="actionButtonsLeft">
              <div class="botonAgregar" style="padding-right: 12px;">
                <v-btn
                  rounded
                  color="#004BAF"
                  class="btnAdd"
                  right
                  @click="abrirModal('add')"
                >
                  <v-icon dark size="medium" class="mr-2">add</v-icon>Agregar
                </v-btn>
              </div>
            </template>

            <tbody slot="body" slot-scope="{ data }">
              <tr :key="item.id" v-for="item in data">
                <td>
                  <template v-if="rol == 'root' || rol == 'admin'">
                    <div class="tblPrincipal">
                      {{ item.nombre_cliente }}
                    </div>
                    <div class="tblSecundario">
                      {{ item.nombre_empresa }}
                    </div>
                    <div
                      class="tblPrincipal"
                      v-if="item.nombre_cliente == null"
                    >
                      General
                    </div>
                    <div
                      class="tblSecundario"
                      v-if="item.nombre_empresa == null"
                    >
                      Prestación General
                    </div>
                  </template>

                  <template v-else>
                    <div class="tblPrincipal">
                      {{ item.nombre_empresa }}
                    </div>
                  </template>
                </td>
                <td>
                  <div class="tblPrincipal">
                    {{ item.nombre }}
                  </div>
                </td>

                <td>
                  <v-tooltip bottom>
                    <template
                      v-slot:activator="{ on }"
                      v-if="item.general != true"
                    >
                      <v-btn
                        v-on="on"
                        slot="activator"
                        class="botonHover"
                        icon
                        fab
                        dark
                        @click="abrirModal('update', item)"
                        small
                      >
                        <v-icon class="tamIconoBoton invertirColorBotones"
                          >edit</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template
                      v-slot:activator="{ on }"
                      v-if="item.general != true"
                    >
                      <v-btn
                        v-on="on"
                        slot="activator"
                        class="botonHover"
                        icon
                        fab
                        dark
                        @click="eliminar(item.id, item.nombre)"
                        small
                      >
                        <v-icon class="tamIconoBoton invertirColorBotonesDelete"
                          >delete</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template
                      v-slot:activator="{ on }"
                      v-if="item.general == true"
                    >
                      <v-btn
                        v-on="on"
                        slot="activator"
                        class="botonHover"
                        icon
                        fab
                        dark
                        @click="abrirModal('update', item, false)"
                        small
                      >
                        <v-icon class="tamIconoBoton invertirColorBotones"
                          >remove_red_eye</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Visualizar</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </data-table>
        </v-col>
      </v-row>
    </v-container>

    <template>
      <v-row>
        <v-dialog v-model="dialog" persistent max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
          </template>

          <v-card>
            <v-card-title class="justify-center">
              <div class="headerModal">
                <img :src="imgModal" class="imgModal" />
                <h2 class="titleModal">{{ titulo_modal }}</h2>
              </div>
            </v-card-title>

            <v-card-text>
              <div id="loadingModal" v-show="!finaliza_carga">
                <div id="loading">
                  <v-progress-circular
                    indeterminate
                    :size="100"
                    :width="7"
                    color="blue"
                  ></v-progress-circular>
                </div>
              </div>
              <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                <v-row>
                  <template v-if="editar">
                    <template v-if="rol == 'root'">
                      <v-col xs="12" sm="6" md="6">
                        <v-autocomplete
                          outlined
                          :items="clientes"
                          item-text="nombre"
                          item-value="id"
                          label="Cliente"
                          persistent-hint
                          v-model="cliente_value"
                          v-validate="'required'"
                          data-vv-name="Cliente"
                          :error-messages="errors.collect('Cliente')"
                        />
                      </v-col>
                      <v-col xs="12" sm="6" md="6">
                        <v-autocomplete
                          outlined
                          :items="empresas"
                          item-text="nombre"
                          item-value="id"
                          label="Empresa"
                          persistent-hint
                          v-model="empresa_id"
                          v-validate="'required'"
                          data-vv-name="Empresa"
                          :error-messages="errors.collect('Empresa')"
                        />
                      </v-col>
                    </template>

                    <template v-if="rol == 'admin'">
                      <v-col xs="12" sm="12" md="12">
                        <v-autocomplete
                          outlined
                          :items="empresas"
                          item-text="nombre"
                          item-value="id"
                          label="Empresa"
                          persistent-hint
                          v-model="empresa_id"
                          v-validate="'required'"
                          data-vv-name="Empresa"
                          :error-messages="errors.collect('Empresa')"
                        />
                      </v-col>
                    </template>
                  </template>

                  <template v-if="rol == 'admin' || rol == 'root'">
                    <v-col xs="12" sm="12" md="8" class="Input2 inputForm">
                      <v-text-field
                        outlined
                        label="Nombre"
                        v-model="vacaciones.nombre"
                        v-validate="'required'"
                        data-vv-name="Nombre"
                        :error-messages="errors.collect('Nombre')"
                        :disabled="!editar"
                      />
                    </v-col>

                    <v-col xs="12" sm="12" md="4" class="Input4 inputForm">
                      <v-text-field
                        outlined
                        type="number"
                        label="Días de aguinaldo"
                        v-model="vacaciones.dias_aguinaldo"
                        v-validate="'required'"
                        data-vv-name="Días de aguinaldo"
                        :error-messages="errors.collect('Días de aguinaldo')"
                        :disabled="!editar"
                      />
                    </v-col>
                  </template>

                  <template v-else>
                    <v-col xs="12" sm="12" md="8" class="Input2">
                      <v-text-field
                        outlined
                        label="Nombre"
                        v-model="vacaciones.nombre"
                        v-validate="'required'"
                        data-vv-name="Nombre"
                        :error-messages="errors.collect('Nombre')"
                        :disabled="!editar"
                      />
                    </v-col>

                    <v-col xs="12" sm="12" md="4" class="Input4">
                      <v-text-field
                        outlined
                        type="number"
                        label="Días de aguinaldo"
                        v-model="vacaciones.dias_aguinaldo"
                        v-validate="'required'"
                        data-vv-name="Días de aguinaldo"
                        :error-messages="errors.collect('Días de aguinaldo')"
                        :disabled="!editar"
                      />
                    </v-col>
                  </template>

                  <v-col xs="12" md="12" class="division"></v-col>
                  <v-col xs="12" md="12">
                    <h3 class="subtitle-vacaciones">Vacaciones</h3>
                  </v-col>

                  <!--  Ramo de Vacaciones  -->
                  <template v-if="editar">
                    <v-col xs="12" sm="2" md="2">
                      <v-autocomplete
                        outlined
                        :items="tipos"
                        item-text="nombre"
                        item-value="id"
                        label="Tipo"
                        persistent-hint
                        v-model="tipo_vacaciones"
                      />
                    </v-col>

                    <v-col xs="12" sm="3" md="3" class="Input5">
                      <v-text-field
                        outlined
                        min="1"
                        max="99"
                        mask="##"
                        label="Días"
                        type="number"
                        v-model="dias_vacaciones"
                      />
                    </v-col>

                    <v-col xs="12" sm="3" md="3" class="Input5">
                      <v-text-field
                        outlined
                        type="number"
                        label="Rango inicial"
                        v-model="rango_inicio"
                      />
                    </v-col>

                    <v-col xs="12" sm="3" md="3" class="Input5">
                      <v-text-field
                        outlined
                        label="Rango final"
                        v-model="rango_fin"
                        :disabled="!rango"
                      />
                    </v-col>

                    <v-col xs="12" sm="1" md="1" class="Input3">
                      <v-btn
                        color="info"
                        class="mt-2"
                        dark
                        fab
                        @click="agregarVacaciones()"
                        small
                      >
                        <v-icon dark>add</v-icon>
                      </v-btn>
                    </v-col>
                  </template>
                </v-row>

                <v-row v-if="detalles.length > 0">
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    class="pt-0 pb-0 ma-0"
                  >
                    <table class="tbl-documentos">
                      <thead class="tbl-header">
                        <tr>
                          <th>Tipo</th>
                          <th>Días</th>
                          <th>Rango inicial</th>
                          <th>Rango final</th>
                          <th v-if="editar">Opciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(detalle, index) in detalles">
                          <tr :key="index" class="modal">
                            <td class="modal">{{ detalle.tipo }}</td>
                            <td class="modal">{{ detalle.dias }}</td>
                            <td class="modal">{{ detalle.rango_inicio }}</td>
                            <td class="modal">{{ detalle.rango_fin }}</td>
                            <td class="modal" v-if="editar">
                              <v-btn
                                class="botonHover mt-1"
                                icon
                                fab
                                dark
                                small
                                @click="onClickDelete(index, detalle.id)"
                              >
                                <v-icon
                                  class="tamIconoBoton invertirColorBotonesDelete"
                                  >delete</v-icon
                                >
                              </v-btn>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions v-show="finaliza_carga">
              <v-layout row>
                <v-flex justify-center>
                  <div
                    class="btnModal"
                    style="margin-bottom:55px; margin-top:30px;"
                  >
                    <v-btn
                      class="btnGuardar pull-right"
                      @click="guardar()"
                      :loading="loading_guardar"
                      v-if="editar"
                    >
                      Guardar
                    </v-btn>
                    <template v-if="!editar">
                        <button
                          class="btnCerrar pull-right"
                          @click="cerrarModal()"
                          :disabled="loading_guardar"
                        >
                          Cerrar
                        </button>
                    </template>

                    <template v-else>
                        <button
                          class="btnCerrar pull-right"
                          @click="cerrarModal()"
                          :disabled="loading_guardar"
                        >
                          Cancelar
                        </button>
                    </template>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </div>
</template>

<script>
import documentoApi from "../api/tipo_documentos";
import empresaApi from "../api/empresas";
import vacacionesApi from "../api/vacaciones";
import clientesApi from "../api/clientes";
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import Datatable from "@/components/datatable/Datatable.vue";
import Notify from "@/plugins/notify";
import PerfectScrollbar from "perfect-scrollbar";

export default {
  components: {
    "data-table": Datatable,
  },
  data() {
    return {
      editar: true,
      imgModal: "/static/svg/prestaciones.svg",
      url: "prestaciones/find",
      columns: [
        {
          label: "Cliente",
          name: "cliente",
          filterable: true,
        },
        {
          label: "Nombre",
          name: "nombre",
          filterable: true,
        },
        {
          label: "Opciones",
          name: "opciones",
          filterable: true,
        },
      ],

      filters: {
        activo: true,
        paginate: true,
        include_padres: true,
        cliente_id: null,
        empresa_id: null,
      },

      detalles: [],
      prestacionesEliminadas: [],
      dias_vacaciones: "",
      tipo_vacaciones: "",
      rango_inicio: "",
      rango_fin: "",
      rango: false,
      tipos: [
        { id: "mes", nombre: "Mes" },
        { id: "años", nombre: "Años" },
        { id: "rango", nombre: "Rango" },
      ],

      empresa_value_search: null,
      cliente_value_search: null,
      empresa_search: [],
      clientes_search: [],

      advancedSearch: {
        nombre: "",
      },

      loading_guardar: false,
      loading: true,
      dialog: false,
      search: "",
      datosLogin: null,
      vacaciones: {
        cliente_id: 0,
        empresa_id: 0,
        nombre: null,
        dias_aguinaldo: null,
        cliente_id: null,
        empresa_id: null,
      },

      titulo_modal: "",
      finaliza_carga: false,
      accion: "",

      clientes: [],
      empresas: [],
      rol: null,
      conteo_parametros: 0,
      carga_final: 0,
      cliente_value: null,
      empresa_id: null,
      seleccion: null,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 2 || "Max 2 digitos",
        mes: (value) => {
          const pattern = /^[0-1]?[0-9]|2[0-4]$/;
          return pattern.test(value) || "Mes invalido.";
        },
      },

      abrir_update: false,
    };
  },
  watch: {
    cliente_value: function(val) {
      this.cambiaCliente(val);
    },
    cliente_value_search: function(val) {
      this.cambiaCliente(val);
    },
    tipo_vacaciones: function(val) {
      if (val != "rango") {
        this.rango = false;
      } else {
        this.rango = true;
      }
    },
  },
  methods: {
    ...mapActions("auth", ["notificacion"]),
    listar() {
      this.datosLogin = this.$session.get("usuario");
      this.rol = this.datosLogin.rol.name;
      this.resetValues();
      if (this.rol == "root") {
        this.getClientes();
      }

      if (this.rol == "admin") {
        this.filters.cliente_id = this.cliente_value = this.datosLogin.cliente_id;
      }

      if (this.rol == "admin-empresa") {
        this.columns[0].label = "Nombre";
        this.filters.empresa_id = this.empresa_id = this.datosLogin.empresa_id;
      }
    },
    agregarVacaciones() {
      if (this.tipo_vacaciones == "") {
        Notify.ErrorToast("Favor de seleccionar un tipo");
        return;
      }

      if (this.tipo_vacaciones == "mes" && this.rango_inicio > 11) {
        Notify.ErrorToast("No se debe de pasar de 11 meses");
        return;
      }

      if (this.rango_inicio == "" || this.dias_vacaciones == "") {
        Notify.ErrorToast("Favor de llenar los campos días y rango inicial");
        return;
      }

      if (this.tipo_vacaciones == "rango" && this.rango_fin == "") {
        Notify.ErrorToast("Es requerido un rango final.");
        return;
      }

      let detalle = {
        id: 0,
        tipo: this.tipo_vacaciones,
        dias: this.dias_vacaciones,
        rango_inicio: this.rango_inicio,
        rango_fin: this.rango_fin,
      };
      this.detalles.push(detalle);
      this.dias_vacaciones = "";
      this.rango_inicio = "";
      this.rango_fin = "";
    },
    async abrirModal(accion, item = null, editar = null) {
      this.resetValues();
      this.finaliza_parametros();
      this.errors.clear();
      this.accion = accion;
      let self = this;

      if (editar != null) {
        this.editar = false;
      } else {
        this.editar = true;
      }

      if (accion == "add") {
        this.titulo_modal = "Registro de prestaciones.";
        this.imgModal = "/static/svg/prestaciones.svg";
        this.finaliza_parametros();
        this.seleccion = 0;
        this.finaliza_carga = true;
      } else if (accion == "update") {
        this.titulo_modal = "Actualizar prestaciones.";
        this.imgModal = "/static/svg/prestaciones.svg";
        this.finaliza_carga = false;

        vacacionesApi
          .getVacacion(item.id)
          .then((response) => {
            self.vacaciones.id = response.id;
            self.vacaciones.nombre = response.nombre;
            self.vacaciones.nombre = response.nombre;
            this.cliente_value = response.cliente_id;
            this.empresa_id = response.empresa_id;
            this.vacaciones.cliente_id = response.cliente_id;
            this.vacaciones.empresa_id = response.empresa_id;
            self.vacaciones.dias_aguinaldo =
              response.prestaciones_info.length > 0
                ? response.prestaciones_info[0].dias_aguinaldo
                : 0;
            let array = response.prestaciones_info;
            if (array.length > 0) {
              for (let i = 0; i < array.length; i++) {
                let d = {
                  id: array[i].id,
                  dias: array[i].dias_vacaciones,
                  rango_inicio: array[i].rango_inicial,
                  rango_fin: array[i].rango_final,
                };

                if (array[i].rango === true) {
                  d.tipo = "Rango";
                } else if (array[i].tipoMes === true) {
                  d.tipo = "Mes";
                } else {
                  d.tipo = "Año";
                }

                self.detalles.push(d);
              }
            }
            this.finaliza_carga = true;
          })
          .catch((ex) => {
            this.respuesta_error(ex);
          });
      }

      if (this.rol == "root") {
        this.getClientes();
        this.finaliza_parametros();
      }
      if (this.rol == "admin") {
        this.cliente_value = this.datosLogin.cliente_id;
        this.cambiaCliente(this.datosLogin.cliente_id, this.empresa_id);
      } else if (this.rol == "admin-empresa") {
        this.cliente_value = this.datosLogin.cliente_id;
        this.empresa_id = this.datosLogin.empresa_id;
      }
      setTimeout(function() {
        document.getElementById("btnModal").click();
      }, 100);
    },
    guardar() {
      this.$validator.validate().then((result) => {
        this.vacaciones.cliente_id = this.cliente_value;
        this.vacaciones.empresa_id = this.empresa_id;

        if (result) {
          this.loading_guardar = true;
          this.vacaciones.prestaciones_info = this.detalles;
          this.vacaciones.prestaciones_eliminadas = this.prestacionesEliminadas;
          if (this.accion === "add") {
            vacacionesApi
              .addVacaciones(this.vacaciones)
              .then((response) => {
                this.respuesta_ok(
                  "Se han generado las prestaciones correctamente"
                );
              })
              .catch((error) => {
                this.respuesta_error(error);
              });
          } else if (this.accion === "update") {
            vacacionesApi
              .updateVacaciones(this.vacaciones)
              .then((response) => {
                this.respuesta_ok("Se ha actualizado correctamente");
              })
              .catch((error) => {
                this.respuesta_error(error);
              });
          }
        }
      });
    },
    onClickDelete(index, id) {
      let eli = { id: id };
      this.prestacionesEliminadas.push(eli);
      this.detalles.splice(index, 1);
    },

    setFilters() {
      let cliente = this.cliente_value_search;
      let empresa = this.empresa_value_search;

      if (this.rol == "admin") {
        cliente = this.datosLogin.cliente_id;
      } else if (this.rol == "admin-empresa") {
        empresa = this.datosLogin.empresa_id;
      } else {
      }

      let filterParams = {
        cliente_id: cliente,
        empresa_id: empresa,
      };

      let defaultParams = {
        activo: true,
        paginate: true,
        include_padres: true,
      };

      if (filterParams != null) {
        Object.assign(defaultParams, filterParams);
      }

      this.filters = defaultParams;
      this.cliente_value_search = null;
      this.empresa_value_search = null;
    },
    loadModalData() {
      this.resetValues();

      if (this.rol == "root") {
        this.getClientes();
      } else if (this.rol == "admin") {
        this.cliente_value_search = this.filters.cliente_id = this.datosLogin.cliente_id;
        this.cambiaCliente(this.datosLogin.cliente_id);
      } else if (this.rol == "admin-empresa") {
        this.empresa_value_search = this.filters.empresa_id = this.datosLogin.empresa_id;
      }
    },

    getClientes() {
      let parametros = { activo: true, paginate: false };
      clientesApi
        .getClientes(parametros)
        .then((response) => {
          this.clientes_search = this.clientes = response.data;
        })
        .catch((err) => {
          this.respuesta_error(err);
        });
    },
    getEmpresas(id) {
      let parametros = { activo: true, paginate: false, cliente_id: id };
      empresaApi
        .getEmpresas(parametros)
        .then((response) => {
          this.empresas = response.data;
          if (this.accion == "update") {
            this.cliente_value = this.vacaciones.cliente_id;
          }
          this.finaliza_parametros();
        })
        .catch((err) => {
          this.respuesta_error(err);
        });
    },
    cambiaCliente(id, empresa = null) {
      let parametros = { activo: true, paginate: false, cliente_id: id };
      empresaApi
        .getEmpresas(parametros)
        .then((response) => {
          this.empresa_search = this.empresas = response.data;
          if (this.accion != "add") {
            this.vacaciones.empresa_id = this.empresa_id;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.finaliza_parametros();
    },

    eliminar(id, nombre) {
      let self = this;
      Notify.Alert(
        "ADVERTENCIA",
        "¿Estás seguro que deseas eliminar la prestacion?",
        "Eliminar",
        () => {
          this.loading = true;
          vacacionesApi
            .deleteVacaciones(id)
            .then(() => {
              this.$refs.tableVacaciones.getData();
              this.listar();
              Notify.Success(
                "Prestacion eliminada",
                "Las Vacaciones han sido eliminadas satisfactoriamente"
              );
            })
            .catch((err) => {
              console.log(err);
              Notify.ErrorToast(err.response.data.error);
            });
        }
      );
    },
    finaliza_parametros() {
      this.carga_final = this.carga_final + 1;
      if (this.carga_final == 30) {
        this.finaliza_carga = true;
      }
    },
    resetValues() {
      this.vacaciones = {
        nombre: null,
        dias_aguinaldo: null,
        cliente_id: 0,
        empresa_id: 0,
      };

      this.anio = "";
      this.mes = "";

      this.cliente_value = null;
      this.cliente_id = null;
      this.empresa_id = null;

      this.cliente_value_search = null;
      this.empresa_value_search = null;

      this.clientes = [];
      this.empresas = [];
      this.tipo_vacaciones = "";
      this.dias_vacaciones = "";
      this.rango_inicio = "";
      this.rango_fin = "";
      this.detalles = [];
      this.prestacionesEliminadas = [];
      this.accion = "";

      this.clientes = [];
      this.empresas = [];
    },
    cerrarModal() {
      this.dialog = false;
      this.resetValues();
      this.conteo_parametros = 0;
      this.carga_final = 0;
      this.loading_guardar = false;
    },
    respuesta_error(err) {
      let error = Object.values(err.response.data.error);
      let leyenda = ``;
      for (var i = 0; i < error.length; i++) {
        leyenda += `* ` + error[i] + `\n`;
      }

      Notify.ErrorToast(leyenda);
    },
    respuesta_ok(msj) {
      this.listar();
      this.$refs.tableVacaciones.getData();
      this.cerrarModal();
      Notify.Success("Operación exitosa", msj);
    },
    init() {
      const elementScroll = document.querySelector("#scroll");
      if (elementScroll) {
        const ps = new PerfectScrollbar(elementScroll, {
          wheelSpeed: 2,
          wheelPropagation: true,
          minScrollbarLength: 20,
          suppressScrollY: true,
        });
      }
      $(".ps__thumb-x").css("position", "fixed");
    },
  },
  created() {
    this.listar();
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.division {
  border-top: 1px solid #c4c4c4;
}

th[class="modal"],
td[class="modal"] {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #96999a;
  line-height: 15px;
  padding: 8px;
  text-transform: capitalize;
  text-align: center !important;
}

tbody tr[class="modal"]:nth-child(1n) {
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #c4c4c4;
}

.tbl-documentos {
  border-collapse: collapse;
  width: 100%;
  margin-top: 15px;
  /* white-space: nowrap; */
  overflow-x: scroll;
  overflow-y: scroll;
}

.tbl-documentos .tbl-header {
  background: #f7f7f7;
  border-radius: 20px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.tbl-header tr{
  height: 35px !important;
}
.subtitle-vacaciones {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.1px;
  color: #101c5a;
}
</style>
